import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-activity-skeleton',
  templateUrl: './activity-skeleton.component.html',
  styleUrls: ['./activity-skeleton.component.scss']
})
export class ActivitySkeletonComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
